import { createContext, useMemo, useState } from 'react'

import { type Message, Role } from '../types/types'

interface ChatContext {
	sendHumanMessage: (messageContent: string) => void
	chatHistoryMessages: Message[]
}

const defaultContext = {
	sendHumanMessage: () => {},
	chatHistoryMessages: [],
}

const ChatBotContext = createContext<ChatContext>(defaultContext)

interface ChatBotProviderProps {
	readonly children: React.ReactNode
}

function ChatBotProvier({ children }: ChatBotProviderProps): React.ReactNode {
	const [chatHistoryMessages, setChatHistoryMessages] = useState<Message[]>([])

	const addMessageHistory = (message: Message) => {
		setChatHistoryMessages([...chatHistoryMessages, message])
	}

	const sendHumanMessage = (messageContent: string) => {
		const newMessage = {
			value: messageContent,
			role: Role.HUMAN,
		}
		addMessageHistory(newMessage)
	}

	const value = useMemo(
		() => ({ sendHumanMessage, chatHistoryMessages }),
		[chatHistoryMessages]
	)

	return (
		<ChatBotContext.Provider value={value}>{children}</ChatBotContext.Provider>
	)
}

export { ChatBotProvier, ChatBotContext }
